import React, { memo } from 'react';
import { Heart, Sparkles, Trophy, Target, Users, Home as HomeIcon, Smile, CheckCircle2 } from 'lucide-react';
export function FamilyWhyParents() {
  return <section className="py-24 bg-off-white" data-id="element-1167">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1168">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-1169">
          <h2 className="text-4xl md:text-5xl text-ink mb-6" data-id="element-1170">
            Why Parents Choose Family Martial Arts
          </h2>
          <p className="text-lg text-gray-warm" data-id="element-1171">
            Parents tell us they came to Storm looking for one activity that
            actually brings the family closer — not another drop-off, not
            another screen. Family classes deliver exactly that.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-1172">
          {[{
          icon: Heart,
          title: 'Family Bonding',
          desc: "Shared experience on the mat builds the kind of memories that don't happen at the sidelines."
        }, {
          icon: Sparkles,
          title: 'Real Fitness',
          desc: 'A full-body workout for parents while kids burn off energy in a structured, positive way.'
        }, {
          icon: Trophy,
          title: 'Confidence',
          desc: 'Belt promotions, small wins, and visible progress give everyone a reason to feel proud.'
        }, {
          icon: Target,
          title: 'Discipline & Respect',
          desc: 'Habits learned on the mat — focus, respect, follow-through — carry into school and home.'
        }, {
          icon: Users,
          title: 'Shared Goals',
          desc: 'Working toward the same belt or technique gives families something positive to talk about every week.'
        }, {
          icon: HomeIcon,
          title: 'Outside-the-House Activity',
          desc: 'Trade an evening of screens for a healthy, energetic activity you actually do together.'
        }, {
          icon: Smile,
          title: 'Beginner-Friendly',
          desc: 'No experience required — for parents or kids. Most family students start from zero.'
        }, {
          icon: CheckCircle2,
          title: 'Supportive Coaching',
          desc: 'Classes staffed with multiple instructors so every family member gets real attention.'
        }].map((b, i) => <div key={i} className="bg-paper p-6 rounded-2xl border border-subtle-gray flex flex-col gap-3" data-id="element-1173">
              <div className="w-12 h-12 bg-storm-red/10 rounded-xl flex items-center justify-center text-storm-red" data-id="element-1174">
                <b.icon className="w-6 h-6" data-id="element-1175" />
              </div>
              <h3 className="text-lg text-ink leading-tight" data-id="element-1176">{b.title}</h3>
              <p className="text-gray-warm text-sm leading-relaxed" data-id="element-1177">{b.desc}</p>
            </div>)}
        </div>
      </div>
    </section>;
}